var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-hover',{scopedSlots:_vm._u([{key:"default",fn:function(ref){
var hover = ref.hover;
return [_c('v-list-item',{class:hover ? 'white--text secondary elevation-12' : 'black--text',attrs:{"active-class":"","dark":hover},on:{"click":function($event){return _vm.onClick()}}},[_c('v-list-item-title',{domProps:{"textContent":_vm._s(_vm.title)}})],1)]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }